import React from "react";
import {
 Tooltip
} from "@mui/material";
import {
    GridToolbarColumnsButton,
    GridToolbarContainer,
    GridToolbarDensitySelector, GridToolbarExport,
    GridToolbarFilterButton
} from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";

export default function AddFiltersExportToolbar({ handleAdd }) {

    const hideActions = localStorage.getItem('hideActions') === "true";

    return (
        <GridToolbarContainer>
            <Box sx= {{
                flexGrow: 1}}>
                {!hideActions &&
                    <Tooltip title={"Add Record"}>
                        <AddCircleOutlineIcon
                            sx={{mr: 3, mb: .5, verticalAlign: 'bottom'}}
                            fontSize="medium" color={'primary'}
                            onClick={() => handleAdd()}/>
                    </Tooltip>
                }
                <GridToolbarColumnsButton />
                <GridToolbarFilterButton sx={{mr: 3}} />
                <GridToolbarDensitySelector />

            </Box>
            <Box sx= {{
                flexGrow: 1}}>
            </Box>
            <Box sx= {{
                flexGrow: 1,
                display: { xs: 'none', md: 'flex' },
                alignContent: 'flex-end',
                justifyContent: 'flex-end',
                ml:30
            }}>
                <GridToolbarExport  />
            </Box>
        </GridToolbarContainer>
    );

}
